import React, { useEffect } from "react";

// UX
import CardPackageOrderUX from "react-lib/apps/HISV3/HCU/CardPackageOrderUX";
import CardSearchPackage from "react-lib/apps/HISV3/HCU/CardSearchPackage";
import CardPurchaseHistory from "react-lib/apps/HISV3/HCU/CardPurchaseHistory";

// Components
import CardMedicalFee from "react-lib/apps/HISV3/BIL/CardMedicalFee";

// Interface
import {
  MasterDataType,
  MasterOptionsType,
  RunSequence,
  State,
  StatusesFilterType,
} from "./sequence/PackagePurchase";
import { PackageDetailType } from "./sequence/SettingPackage";
import { PickedState } from "react-lib/apps/MEH/types/MeBillingType";

// Config
import CONFIG from "config/config";

// Types
type CardPackageOrderProps = {
  onEvent: (e: any) => any;
  setProp: (key: string, value: any, callback?: () => any) => any;
  // seq
  runSequence: RunSequence;
  PackagePurchaseSequence?: State["PackagePurchaseSequence"];
  PackageOrderSequence?: Record<string, any>;
  buttonLoadCheck?: Record<string, any>;
  errorMessage?: Record<string, any>;
  // Filter
  statusesFilter?: StatusesFilterType;
  // CommonInterface
  searchedItemListWithKey?: Record<string, any>;
  successMessage?: Record<string, any>;
  // options
  masterData?: MasterDataType;
  masterOptions?: MasterOptionsType;
  // config
  isMeBilling?: boolean;
  hideTitle?: boolean;
  hidePackageTypeFilter?: boolean;
  hideProgramNameFilter?: boolean;
  hideDivisionFilter?: boolean;
  showMedicalFee?: boolean;
  showPackageNameFilter?: boolean;
  showOptimizePackage?: boolean;
  filterByDivision?: boolean;
  packageBinderTitle?: string;
  selectedDivision?: Record<string, any> | null; // default performed_division,
  inCartFilter?: boolean;
  // labels (optional overrides)
  confirmHeaderText?: string;
  selectPromptText?: string;
  confirmButtonText?: string;
  onClickDescription?: (data: PackageDetailType) => void;
  onClickAppointment?: () => void;
  languageUX: "en" | "th";

  // CardMedicalFee
  patientInfo?: Record<string, any>;
  selectedEncounter?: Record<string, any>;
   // Invoice items
  invoiceItemByModes?: Record<string, any>[];
  invoiceItemByOrders?: Record<string, any>[];
  invoiceItemByItems?: Record<string, any>[];
  invoiceItemPackageList?: Record<string, any>[];
  // Orders
  patientOrders?: Record<string, any>[];
  refundOrders?: Record<string, any>;
  // Filters / Status
  medicalFeeFilter?: Record<string, any>;
  patientEncounterLockerStatus?: Record<string, any>[];
  encounterSuspension?: Record<string, any>;
  // Bill / Payment
  BillPaymentSequence?: Record<string, any> | null;
  billPendingDetail?: Record<string, any>;
  billReportPrint?: Record<string, any>;
  bilReceiptCodeDetail?: Record<string, any>;
  faxClaimItemList?: Record<string, any>;
  taskTrackingList?: Record<string, any>;
  // Language
  billingPatientLanguage?: any;
}  & Pick<
  PickedState,
  | "loadingStatus"
  | "qrCodePayment"
  | "userProfile"
>;

const CardPackageOrder = (props: CardPackageOrderProps) => {
  return (
    <div>
      <CardPackageOrderUX
        hideTitle={props.hideTitle}
        searchPackage={
          <CardSearchPackage
            setProp={props.setProp}
            onEvent={props.onEvent}
            // seq
            runSequence={props.runSequence}
            PackageOrderSequence={props.PackageOrderSequence}
            // Filter
            statusesFilter={props.statusesFilter}
            // CommonInterface
            searchedItemListWithKey={props.searchedItemListWithKey}
            buttonLoadCheck={props.buttonLoadCheck}
            errorMessage={props.errorMessage}
            successMessage={props.successMessage}
            hideTitle={props.hideTitle}
            hidePackageTypeFilter={props.hidePackageTypeFilter}
            hideProgramNameFilter={props.hideProgramNameFilter}
            showPackageNameFilter={props.showPackageNameFilter}
            filterByDivision={props.filterByDivision}
            onClickDescription={props.onClickDescription}
            // options
            masterOptions={props.masterOptions}
            // config
            isMeBilling={props.isMeBilling}
            languageUX={props.languageUX}
            showMedicalFee={props.showMedicalFee}
          />
        }
        purchaseHistory={
          props.showMedicalFee ? (
            <CardMedicalFee
              showAuthorize={CONFIG.FAX_CLAIM_AUTHORIZE}
              onEvent={props.onEvent}
              setProp={props.setProp as any}
              patientInfo={props.patientInfo}
              selectedEncounter={props.selectedEncounter}
              invoiceItemByModes={props.invoiceItemByModes}
              invoiceItemByOrders={props.invoiceItemByOrders}
              invoiceItemByItems={props.invoiceItemByItems}
              patientOrders={props.patientOrders}
              refundOrders={props.refundOrders}
              medicalFeeFilter={props.medicalFeeFilter}
              patientEncounterLockerStatus={props.patientEncounterLockerStatus}
              showFilter={!CONFIG.FEATURE_DISABLED_UP_TO_VERS["202401"]}
              encounterSuspension={props.encounterSuspension}
              BillPaymentSequence={props.BillPaymentSequence}
              qrCodePayment={props.qrCodePayment}
              loadingStatus={props.loadingStatus}
              errorMessage={props.errorMessage}
              buttonLoadCheck={props.buttonLoadCheck}
              masterOptions={props.masterOptions}
              taskTrackingList={props.taskTrackingList}
              billPendingDetail={props.billPendingDetail}
              bilReceiptCodeDetail={props.bilReceiptCodeDetail}
              billReportPrint={props.billReportPrint}
              faxClaimItemList={props.faxClaimItemList}
              invoiceItemPackageList={props.invoiceItemPackageList}
              billingPatientLanguage={props.billingPatientLanguage}
              selectedDivision={props.selectedDivision}
              languageUX={props.languageUX}
              // config
              isMeBilling={true}
              isHideBillPendingDetail={true}
              isHidePatientOrders={true}
              isPackageOrder={true}
              userProfile={props.userProfile}
            />
          ) : (
            <CardPurchaseHistory
              setProp={props.setProp}
              onEvent={props.onEvent}
              // seq
              runSequence={props.runSequence}
              PackagePurchaseSequence={props.PackagePurchaseSequence}
              // data
              masterData={props.masterData}
              // Filter
              statusesFilter={props.statusesFilter}
              hidePackageTypeFilter={props.hidePackageTypeFilter}
              hideProgramNameFilter={props.hideProgramNameFilter}
              hideDivisionFilter={props.hideDivisionFilter}
              showPackageNameFilter={props.showPackageNameFilter}
              filterByDivision={props.filterByDivision}
              hideTitle={props.hideTitle}
              packageBinderTitle={props.packageBinderTitle}
              // labels
              confirmHeaderText={props.confirmHeaderText}
              selectPromptText={props.selectPromptText}
              confirmButtonText={props.confirmButtonText}
              // CommonInterface
              searchedItemListWithKey={props.searchedItemListWithKey}
              buttonLoadCheck={props.buttonLoadCheck}
              errorMessage={props.errorMessage}
              onClickDescription={props.onClickDescription}
              onClickAppointment={props.onClickAppointment}
              // options
              masterOptions={props.masterOptions}
              languageUX={props.languageUX}
              // config
              isPackageOrder={true}
              showOptimizePackage={props.showOptimizePackage}
              inCartFilter={props.inCartFilter}
            />
          )
        }
      />
    </div>
  );
};

CardPackageOrder.displayName = "CardPackageOrder";

export default React.memo(CardPackageOrder);
